<template>
  <v-dialog
    fullscreen
    eager
    v-model="dialog"
    hide-overlay
    content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">

              <v-text-field
                  outlined
                  v-model="emergencyCenter.name"
                  :label="$t('common:name')"
              />

              <v-text-field
                  outlined
                  v-model="emergencyCenter.street"
                  :label="$t('common:address')"
              />

              <v-container class="pt-0 pl-0 pr-0 pb-0">
                <v-row justify="space-around">
                  <v-col cols="12" md="3">
                    <v-text-field
                        outlined
                        v-model="emergencyCenter.zip"
                        :label="$t('common:zip')"
                    />
                  </v-col>

                  <v-col cols="12" md="9">
                    <v-text-field
                        outlined
                        v-model="emergencyCenter.city"
                        :label="$t('common:city')"
                    />
                  </v-col>
                </v-row>
              </v-container>

              <v-select
                  :items="countries"
                  item-text="translatedName"
                  item-value="id"
                  v-model="emergencyCenter.country"
                  :label="$t('common:country')"
                  outlined
              />

              <v-text-field
                  outlined
                  v-model="emergencyCenter.contactName"
                  :label="$t('settings/settings:emergency-center.contact-name')"
              />


            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                  outlined
                  v-model="emergencyCenter.contactEmail"
                  :label="$t('common:email')"
              />

              <v-text-field
                  outlined
                  v-model="emergencyCenter.contactPhone"
                  :label="$t('common:phone')"
              />

              <v-text-field
                  outlined
                  v-model="emergencyCenter.mailSubject"
                  :label="$t('settings/settings:emergency-center.mail-subject')"
              />

              <v-textarea
                  outlined
                  v-model="emergencyCenter.mailContent"
                  :label="$t('settings/settings:emergency-center.mail-template')"
                  auto-grow
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                  elevation="0"
                  flat
                  tile
                  class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:emergency-center.emergency-center') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:emergency-center.emergency-center') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import EmergencyCenterService from '@/modules/settings/services/emergency-center-service';
import EmergencyCenter from '@/modules/settings/data/emergency-center'
import {ruleRequired} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: "EmergencyForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  props: {
    countries: Array
  },
  data() {
    return {
      dialog: false,
      edit: false,
      emergencyCenter: null
    }
  },
  methods: {
    ruleRequired,
    initialization(item) {
      this.emergencyCenter = new EmergencyCenter();
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.emergencyCenter = item;
        this.edit = true;
      }

      this.dialog = true;
    },
    updateForm() {
      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      EmergencyCenterService.saveEmergencyCenter(
        this.emergencyCenter,
        () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
            }

            this.$emit('updateTable');
        },
        () => {
          if (!this.edit) {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
          } else {
            Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
          }
        }
      )
    }
  }
}
</script>
